import React, { useState, useEffect, useCallback } from 'react';
import { getAuthHeaders } from '../lib/api'; // Assume this exists, adjust if needed
import { getApiBase } from '../utils/api_base'; // Adjust import path

// Minimal auth header getter - use existing auth mechanism
function authHeader() {
  const token = localStorage.getItem('xf_token') || localStorage.getItem('token');
  return token ? { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' };
}

export function GlassesDeviceManager() {
  const [devices, setDevices] = useState<any[]>([]);
  const [bindCode, setBindCode] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const base = localStorage.getItem('xf_api_base') || 'https://os.aizjyun.cn';

  const fetchDevices = useCallback(async () => {
    try {
      const res = await fetch(base + '/api/device/list', { headers: authHeader() });
      const data = await res.json();
      if (data.devices) setDevices(data.devices);
    } catch (e) { console.error('fetch devices err', e); }
  }, [base]);

  useEffect(() => { fetchDevices(); }, [fetchDevices]);

  async function doBind() {
    if (!bindCode.trim()) return;
    setLoading(true); setMsg('');
    try {
      const res = await fetch(base + '/api/device/bind', {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ bindCode: bindCode.trim().toUpperCase() }),
      });
      const data = await res.json();
      if (data.success) { setMsg('绑定成功！'); setBindCode(''); fetchDevices(); }
      else setMsg(data.error || '绑定失败');
    } catch (e) { setMsg('网络错误'); }
    finally { setLoading(false); }
  }

  async function doUnbind(deviceId: string) {
    try {
      await fetch(base + '/api/device/unbind', { method: 'POST', headers: authHeader(), body: JSON.stringify({ deviceId }) });
      fetchDevices();
    } catch (e) { console.error('unbind err', e); }
  }

  async function doRenew(deviceId: string) {
    try {
      await fetch(base + '/api/device/renew', { method: 'POST', headers: authHeader(), body: JSON.stringify({ deviceId }) });
      fetchDevices();
    } catch (e) { console.error('renew err', e); }
  }

  return (
    <div style={{ padding: 20, color: '#f5f5f5', background: '#0a0a0a', minHeight: '100vh', fontFamily: 'PingFang SC' }}>
      <h2 style={{ color: '#FFD700', marginBottom: 16 }}>眼镜设备管理</h2>

      {/* 绑定表单 */}
      <div style={{ border: '1px solid rgba(255,215,0,.3)', borderRadius: 12, padding: 16, marginBottom: 20, background: 'rgba(255,215,0,.04)' }}>
        <h3 style={{ color: '#FFD700', marginBottom: 8 }}>绑定新设备</h3>
        <p style={{ fontSize: 13, color: '#9a9a9a', marginBottom: 10 }}>眼镜启动后会显示 6 位配对码，在此输入完成绑定。</p>
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            value={bindCode}
            onChange={e => setBindCode(e.target.value.toUpperCase().slice(0, 6))}
            placeholder="输入 6 位配对码"
            maxLength={6}
            style={{
              flex: 1, padding: '8px 12px', borderRadius: 8, border: '1px solid rgba(255,215,0,.3)',
              background: '#0d0d0d', color: '#FFD700', fontSize: 18, fontFamily: 'monospace', letterSpacing: 4, textAlign: 'center',
            }}
          />
          <button onClick={doBind} disabled={loading}
            style={{ padding: '8px 24px', borderRadius: 8, background: 'linear-gradient(180deg, #FFD700, #e6b800)', color: '#1a1a1a', fontWeight: 700, border: 'none', cursor: 'pointer' }}
          >{loading ? '绑定中…' : '绑定'}</button>
        </div>
        {msg && <p style={{ marginTop: 8, color: msg.includes('成功') ? '#2ecc71' : '#e74c3c', fontSize: 13 }}>{msg}</p>}
      </div>

      {/* 设备列表 */}
      <h3 style={{ color: '#FFD700', marginBottom: 8 }}>已绑设备</h3>
      {devices.length === 0 && <p style={{ color: '#9a9a9a', fontSize: 13 }}>暂无已绑设备</p>}
      {devices.map((d) => (
        <div key={d.id} style={{
          border: '1px solid rgba(255,215,0,.15)', borderRadius: 10, padding: 14, marginBottom: 8,
          background: 'rgba(255,215,0,.03)', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <div>
            <div style={{ fontSize: 15, color: '#e8e8e8', fontWeight: 600 }}>{d.name}</div>
            <div style={{ fontSize: 11, color: '#9a9a9a', marginTop: 4 }}>
              配对码：<span style={{ fontFamily: 'monospace', color: '#FFD700' }}>{d.bindCode || '—'}</span>
              &nbsp;|&nbsp; Token：{d.tokenPreview || '—'}
            </div>
            <div style={{ fontSize: 11, color: '#9a9a9a', marginTop: 2 }}>
              状态：<span style={{ color: d.status === 'bound' ? '#2ecc71' : '#e74c3c' }}>{d.status}</span>
              {d.expiresAt && <span>&nbsp;|&nbsp;到期：{new Date(d.expiresAt).toLocaleDateString()}</span>}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 6 }}>
            {d.status === 'bound' && (
              <button onClick={() => doRenew(d.id)}
                style={{ padding: '4px 12px', borderRadius: 6, border: '1px solid rgba(46,204,113,.4)', background: 'transparent', color: '#2ecc71', cursor: 'pointer', fontSize: 12 }}
              >续期 30 天</button>
            )}
            <button onClick={() => doUnbind(d.id)}
              style={{ padding: '4px 12px', borderRadius: 6, border: '1px solid rgba(231,76,60,.4)', background: 'transparent', color: '#e74c3c', cursor: 'pointer', fontSize: 12 }}
            >解绑</button>
          </div>
        </div>
      ))}
    </div>
  );
}
